import { createFileRoute } from "@tanstack/react-router";

import { SelfProfileMemory } from "@/features/settings/components/SelfProfileMemory";

/**
 * Settings → Memoria personale — Wave 2 trust-first personalisation surface.
 *
 * Full-screen route peer to ``/settings/privacy``. The component owns its
 * own ``SurfaceLayout`` chrome (mirrors ``NotificationPreferences`` /
 * ``ProfileSettings``), so this file is a thin route wrapper.
 */
export const Route = createFileRoute("/_authed/_modal/settings/memory")({
  component: SelfProfileMemory,
});
